import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-await-in-loop */
/* eslint-disable no-promise-executor-return */
import React, { useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { AppRoot, SplitLayout, SplitCol, View, ModalRoot, ModalPage, ModalPageHeader, PanelHeaderButton, Button, Div, Epic, Tabbar, TabbarItem, Input, Header, CardGrid, Card, SimpleCell, Avatar, FormItem, Snackbar, ScreenSpinner, Title } from '@vkontakte/vkui';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Icon24ChevronCompactLeft, Icon24Dismiss, Icon28CancelCircleFillRed, Icon28CheckCircleFill, Icon28DiamondOutline, Icon28GlobeOutline, Icon28HomeOutline, Icon28SettingsOutline } from '@vkontakte/icons';
import copy from 'copy-to-clipboard';
import { Address } from 'ton';
import { Coins, Address as AddressTon3 } from 'ton3';
import moment from 'moment';
import { VldBuilder, vlds } from 'validatorus-react';
import { HeaderBlock } from './layout/header';
import '@vkontakte/vkui/dist/vkui.css';
import './style.css';
import { Main } from './pages/main';
import { Reg } from './pages/reg';
import { Settings } from './pages/settings';
import { Apps } from './pages/apps';
import { Nft } from './pages/nft';
import { Word } from './pages/word24';
import { CustomWallet } from './logic/wallet';
import { DeLabUtils } from './logic/utils';
import { CustomEventApi } from './logic/events';
import axios from 'axios';
function smlAddr(address) {
    if (!address) {
        return '';
    }
    return address.slice(0, 7) + '...' + address.slice(address.length - 4, address.length);
}
function rawToTon(address) {
    if (!address) {
        return '';
    }
    const addr = new AddressTon3(address, { bounceable: true }).toString('base64');
    return addr;
}
export const App = () => {
    const [activeModal, setActiveModal] = React.useState(null);
    const [snackbar, setSnackbar] = React.useState(null);
    const [popout, setPopout] = React.useState(null);
    const [firstRender, setFirstRender] = React.useState(false);
    const [addressUser, setAddressUser] = React.useState(undefined);
    const [listTokens, setListTokens] = React.useState(undefined);
    const [walletInfo, setWalletInfo] = React.useState(undefined);
    const [errorText, setErrorText] = React.useState('');
    const [selectTokenToTransfer, setSelectTokenToTransfer] = React.useState(undefined);
    const [transModal, setTransModal] = React.useState(undefined);
    const [transModalFull, setTransModalFull] = React.useState(undefined);
    const [eventApi, setEventApi] = React.useState(undefined);
    const [transFromEvent, setTransFromEvent] = React.useState(undefined);
    const [transStatus, setTransStatus] = React.useState(undefined);
    const [connectStatus, setConnectStatus] = React.useState(undefined);
    const [tonConnect2Abount2, setTonConnect2Abount2] = React.useState(undefined);
    const isDesktop = window.innerWidth >= 650;
    const location = useLocation();
    const history = useNavigate();
    function openPop() {
        setPopout(_jsx(ScreenSpinner, { state: "loading" }));
    }
    function closePop(type) {
        if (type)
            setPopout(_jsx(ScreenSpinner, { state: "done", "aria-label": "Success" }));
        else
            setPopout(_jsx(ScreenSpinner, { state: "error", "aria-label": "Error" }));
        setTimeout(() => {
            setPopout(null);
        }, 1000);
    }
    function consoleLog(data, type = false) {
        setSnackbar(_jsx(Snackbar, { before: type ? _jsx(Icon28CheckCircleFill, {}) : _jsx(Icon28CancelCircleFillRed, {}), onClose: () => setSnackbar(null), children: data }));
    }
    const wall = new CustomWallet();
    const psw = new VldBuilder()
        .with(vlds.VLen, 8, 160)
        .withFname('Password');
    const address = new VldBuilder()
        .with(vlds.VLen, 47, 49)
        .withFname('Address');
    const amount = new VldBuilder()
        .with(vlds.VNumber, 0, 1000000000)
        .withFname('Amount');
    const comment = new VldBuilder()
        .with(vlds.VLen, 0, 128)
        .withFname('Comment');
    async function deletedAccount() {
        const res = await wall.delWallet(psw.value);
        psw.reset();
        if (!res) {
            setErrorText('Incorrect password');
            consoleLog('Incorrect password', false);
            return;
        }
        history('/reg');
        setAddressUser(undefined);
        setListTokens(undefined);
        setWalletInfo(undefined);
        setErrorText('');
        setActiveModal(null);
        consoleLog('Success deleted', true);
    }
    function chooseToken(symbol) {
        setSelectTokenToTransfer(symbol);
        setActiveModal('send_amount');
    }
    async function transMakeToCompl(token = selectTokenToTransfer, data) {
        openPop();
        if (!token) {
            consoleLog('error Token', false);
            closePop(false);
            eventApi?.updateRes(false);
            return;
        }
        if (token === 'ton') {
            try {
                const trans = {
                    to: Address.parse(address.value),
                    amount: new Coins(amount.value).toNano().toString(),
                    data
                };
                if (transFromEvent)
                    trans.data = transFromEvent.data;
                trans.comment = comment.value === '' ? undefined : comment.value;
                const tr = await wall.signMsg(trans, psw.value);
                console.log(tr);
                if (!tr) {
                    closePop(false);
                    consoleLog('Incorrect password', false);
                    setErrorText('Incorrect password');
                    eventApi?.updateRes(false);
                }
                else {
                    closePop(true);
                    setActiveModal(null);
                    consoleLog('Success send', true);
                    eventApi?.updateRes(true);
                }
                // return tr
            }
            catch (error) {
                closePop(false);
                consoleLog('Incorrect password', false);
                setErrorText('Incorrect password');
                console.error(error);
                eventApi?.updateRes(false);
            }
        }
        else {
            const trans = {
                to: Address.parse(address.value),
                amount: new Coins(amount.value).toNano().toString()
            };
            const tr = await wall.signMsgJetton(trans, psw.value, token.wallet_address.address);
            console.log(tr);
            if (!tr) {
                closePop(false);
                consoleLog('Incorrect password', false);
                setErrorText('Incorrect password');
                eventApi?.updateRes(false);
            }
            else {
                closePop(true);
                setActiveModal(null);
                consoleLog('Success send', true);
                eventApi?.updateRes(true);
            }
            // consoleLog('Incorrect token', false)
            // setErrorText('Incorrect token')
        }
    }
    function checkAndReturnAddress(address1, address2) {
        if (address1 && !address2) {
            let res = smlAddr(rawToTon(address1.address));
            if (address1.name && address1.name !== '')
                res = address1.name;
            return res;
        }
        if (address2 && !address1) {
            let res = smlAddr(rawToTon(address2.address));
            if (address2.name && address2.name !== '')
                res = address2.name;
            return res;
        }
        if (!address1 && !address2) {
            return '';
        }
        if (addressUser && address1 && address2) {
            if (rawToTon(address1.address) === addressUser) {
                let res = smlAddr(rawToTon(address2.address));
                if (address2.name && address2.name !== '')
                    res = address2.name;
                return res;
            }
            let res = smlAddr(rawToTon(address1.address));
            if (address1.name && address1.name !== '')
                res = address1.name;
            return res;
        }
        if (!addressUser && address1 && address2) {
            let res = smlAddr(rawToTon(address1.address));
            if (address1.name && address1.name !== '')
                res = address1.name;
            return res;
        }
        return '';
    }
    function base64ToUtf(text) {
        if (!text) {
            return undefined;
        }
        if (text === '') {
            return undefined;
        }
        const newText = Buffer.from(text, 'base64').toString('utf-8');
        if (newText.indexOf('�') !== -1
            || newText.indexOf('�') !== -1) {
            return undefined;
        }
        return newText;
    }
    async function cbEventApiSend(param, type = 0) {
        let pcc;
        console.log('cbEventApiSend', param);
        if (type === 0) {
            pcc = param[0];
            if (!pcc) {
                consoleLog('#4001 Error params data', false);
                return undefined;
            }
            // {
            //     value: Number(transaction.value),
            //     to: transaction.to,
            //     dataType: 'boc',
            //     data: transaction.payload,
            //     stateInit: transaction.stateInit
            // }
        }
        else {
            let msgs;
            try {
                msgs = JSON.parse(param[0]);
            }
            catch (error) {
                console.error(error);
                eventApi?.updateRes(false);
                consoleLog('#4002 Error parse params', false);
                return undefined;
            }
            console.log(msgs);
            pcc = {
                value: msgs.messages[0].amount,
                to: msgs.messages[0].address,
                data: msgs.messages[0].payload,
                dataType: 'boc'
            };
        }
        console.log(pcc);
        address.change(pcc.to);
        amount.change(Coins.fromNano(pcc.value).toString());
        setTransFromEvent(pcc);
        setSelectTokenToTransfer('ton');
        setActiveModal('send_confirm');
        return true;
    }
    async function tonProof() {
        const key = await wall.getKeyPair(psw.value);
        if (!key) {
            consoleLog('Invalid psw', false);
            setActiveModal('ton_proof');
            psw.reset(true, true);
            // console.error('ton proof error')
            // if (eventApi) eventApi.updateRes(false)
            return false;
        }
        if (eventApi)
            eventApi.setKey(key);
        if (eventApi)
            eventApi.updateRes(true);
        return true;
    }
    function checkToTrans(_address, _amount) {
        if (_address === '') {
            consoleLog('Error address', false);
            return false;
        }
        if (_amount === '') {
            consoleLog('Error amount', false);
            return false;
        }
        try {
            const add = Address.parse(_address);
        }
        catch (error) {
            consoleLog('Error address', false);
            return false;
        }
        if (!walletInfo) {
            consoleLog('Error null #506', false);
            return false;
        }
        if (walletInfo.balance === 0 || walletInfo.balance < Number(amount) * 10 ** 9) {
            consoleLog('Small balance TON', false);
            return false;
        }
        setActiveModal('sign_trans');
        return true;
    }
    async function connect(url) {
        setActiveModal('connect2');
        const res = await axios.get(url);
        console.log(res.data);
        setTonConnect2Abount2(res.data);
        return true;
    }
    useEffect(() => {
        if (!firstRender) {
            setFirstRender(true);
            if (wall.isSaveWallet()) {
                const loadData = wall.loadHashSaveData();
                CustomWallet.balanceTon(loadData.public).then((bal) => {
                    eventApi?.updateBalance(bal ?? '0');
                });
                setEventApi(new CustomEventApi(loadData.address, loadData.public, '0', cbEventApiSend, connect));
                setAddressUser(loadData.address);
                history('/');
            }
            else {
                history('/reg');
            }
        }
    }, []);
    useEffect(() => {
        if (activeModal === null) {
            psw.reset(true, true);
            address.reset(true, true);
            amount.reset(true, true);
            comment.reset(true, true);
            setSelectTokenToTransfer(undefined);
            setTransFromEvent(undefined);
            eventApi?.updateRes(false);
        }
    }, [activeModal]);
    const modalRoot = (_jsxs(ModalRoot, { activeModal: activeModal, children: [_jsx(ModalPage, { id: 'recive', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                dynamicContentHeight: true, header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: "Receive" }), children: _jsxs(Div, { style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        flexDirection: 'column',
                        width: '100%',
                        boxSizing: 'border-box'
                    }, children: [_jsx(Header, { children: "Get TON and other tokens" }), _jsx("div", { className: "qr-block", children: _jsx(QRCodeSVG, { value: 'ton://transfer/' + addressUser }) }), _jsx(CardGrid, { size: "l", children: _jsx(Card, { children: _jsx(Div, { children: _jsx("span", { style: {
                                            userSelect: 'all',
                                            fontSize: '11px'
                                        }, children: addressUser }) }) }) }), _jsx(Button, { style: { marginTop: '12px' }, stretched: true, size: 'l', onClick: () => {
                                copy(addressUser ?? '');
                                consoleLog('Copyed', true);
                            }, children: "Copy address" })] }) }), _jsx(ModalPage, { id: 'send_list_token', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), before: _jsx(PanelHeaderButton, { onClick: () => setActiveModal('send_address'), children: _jsx(Icon24ChevronCompactLeft, {}) }), children: "\u0421hoose token" }), children: listTokens && walletInfo
                    ? _jsxs(Div, { children: [_jsx("div", { style: { textAlign: 'center', paddingBottom: '12px' }, children: "The amount will need to be entered next" }), _jsxs(CardGrid, { size: "l", children: [_jsx(Card, { children: _jsx(SimpleCell, { expandable: true, before: _jsx(Avatar, { src: 'https://ton.org/download/ton_symbol.svg', size: 42 }), onClick: () => chooseToken('ton'), subtitle: `${DeLabUtils.fromNanoToString(walletInfo.balance ?? '0')} TON`, children: "TON" }) }), _jsx(Card, { children: listTokens.filter(j => j.metadata).filter(j => BigInt(j.balance) > 0).map((jetton, key) => (_jsx(SimpleCell, { expandable: true, before: _jsx(Avatar, { src: jetton.metadata?.image ?? '', size: 42 }), subtitle: `${DeLabUtils.fromNanoToString(jetton.balance)} ${jetton.metadata?.symbol}`, onClick: () => chooseToken(jetton), children: jetton.metadata?.name }, key))) })] })] }) : null }), _jsx(ModalPage, { id: 'send_address', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: "Send" }), children: listTokens && walletInfo
                    ? _jsxs(Div, { children: [_jsx(FormItem, { top: "Wallet address", bottom: address.error, children: _jsx(Input, { value: address.value, onChange: e => address.change(e.target.value), status: address.iserr }) }), _jsx(FormItem, { children: _jsx(Button, { stretched: true, size: "l", onClick: () => setActiveModal('send_list_token'), disabled: address.iserr !== 'valid', children: "Next" }) })] }) : null }), _jsx(ModalPage, { id: 'send_amount', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                header: _jsxs(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), before: _jsx(PanelHeaderButton, { onClick: () => setActiveModal('send_list_token'), children: _jsx(Icon24ChevronCompactLeft, {}) }), children: ["Send ", selectTokenToTransfer === 'ton' ? 'TON' : selectTokenToTransfer?.metadata?.symbol.toUpperCase()] }), children: listTokens && walletInfo && selectTokenToTransfer
                    ? _jsxs(Div, { children: [_jsx(CardGrid, { size: "l", children: selectTokenToTransfer === 'ton' ? _jsx(Card, { children: _jsx(SimpleCell, { disabled: true, before: _jsx(Avatar, { src: 'https://ton.org/download/ton_symbol.svg', size: 42 }), onClick: () => chooseToken('ton'), subtitle: `${DeLabUtils.fromNanoToString(walletInfo.balance ?? '0')} TON`, children: "TON" }) })
                                    : _jsx(Card, { children: _jsx(SimpleCell, { disabled: true, before: _jsx(Avatar, { src: selectTokenToTransfer.metadata?.image ?? '', size: 42 }), subtitle: `${DeLabUtils
                                                .fromNanoToString(selectTokenToTransfer.balance)} ${selectTokenToTransfer.metadata?.symbol}`, onClick: () => chooseToken(selectTokenToTransfer), children: selectTokenToTransfer.metadata?.name }) }) }), _jsx(FormItem, { top: "Amount", bottom: amount.error, children: _jsx(Input, { value: amount.value, onChange: e => amount.change(e.target.value), status: amount.iserr, type: "number" }) }), selectTokenToTransfer === 'ton' ? _jsx(FormItem, { top: "Comment (optional)", bottom: comment.error, children: _jsx(Input, { value: comment.value, onChange: e => comment.change(e.target.value), status: comment.iserr }) }) : null, _jsx(FormItem, { children: _jsx(Button, { stretched: true, size: "l", onClick: () => setActiveModal('send_confirm'), disabled: amount.iserr !== 'valid', children: "Next" }) })] }) : null }), _jsx(ModalPage, { id: 'send_confirm', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                dynamicContentHeight: true, header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), before: _jsx(PanelHeaderButton, { onClick: () => setActiveModal('send_amount'), children: _jsx(Icon24ChevronCompactLeft, {}) }), children: "Confirm transfer" }), children: listTokens && walletInfo
                    ? _jsxs(Div, { children: [_jsx(CardGrid, { size: "l", children: _jsxs(Card, { children: [_jsx(SimpleCell, { disabled: true, after: selectTokenToTransfer === 'ton'
                                                ? 'TON' : selectTokenToTransfer?.metadata?.symbol, subtitle: 'Token' }), _jsx(SimpleCell, { after: smlAddr(address.value), disabled: true, subtitle: 'Address' }), _jsx(SimpleCell, { after: amount.value, subtitle: 'Amount', disabled: true })] }) }), _jsx("br", {}), _jsx(Button, { stretched: true, size: "l", onClick: () => checkToTrans(address.value, amount.value), disabled: amount.error !== '', children: "Send" })] }) : null }), _jsx(ModalPage, { id: 'sign_trans', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: "Sign transaction" }), children: listTokens && walletInfo
                    ? _jsxs(Div, { children: [_jsx(FormItem, { top: "Password", bottom: psw.error, children: _jsx(Input, { value: psw.value, onChange: e => psw.change(e.target.value), status: psw.iserr, type: 'password' }) }), _jsx(FormItem, { bottom: errorText, children: _jsx(Button, { stretched: true, size: "l", onClick: () => transMakeToCompl(), disabled: psw.iserr !== 'valid', children: "Sign" }) })] }) : null }), _jsx(ModalPage, { id: 'transaction', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: transModal && transModalFull ? _jsx("span", { children: rawToTon(transModal.destination?.address) === addressUser
                            ? `+ ${DeLabUtils.fromNanoToString(transModal.value)} TON`
                            : `- ${DeLabUtils.fromNanoToString(transModal.value)} TON` }) : 'Transaction' }), children: transModal && transModalFull
                    ? _jsx(Div, { children: _jsx(CardGrid, { size: "l", children: _jsxs(Card, { children: [_jsx(SimpleCell, { after: checkAndReturnAddress(transModal.source, transModal.destination), href: 'https://tonapi.io/account/' + checkAndReturnAddress(transModal.source, transModal.destination), target: '_blank', expandable: true, subtitle: rawToTon(transModal.destination?.address) === addressUser ? 'Sender' : 'Recipient' }), _jsx(SimpleCell, { after: smlAddr(transModalFull.hash), href: 'https://tonapi.io/transaction/' + transModalFull.hash, target: '_blank', expandable: true, subtitle: 'Hash' }), _jsx(SimpleCell, { after: Coins.fromNano(transModal.fwd_fee).toString(), subtitle: 'Fee', disabled: true }), _jsx(SimpleCell, { after: moment(transModalFull.utime * 1000).format('MMM DD, hh:mm'), subtitle: 'Date', disabled: true }), base64ToUtf(transModal.msg_data) ? _jsx(SimpleCell, { after: base64ToUtf(transModal.msg_data), subtitle: 'Comment', multiline: true, disabled: true }) : null] }) }) }) : null }), _jsx(ModalPage, { id: 'connect2', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                dynamicContentHeight: true, header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: "Ton connect 2.0" }), children: tonConnect2Abount2 && eventApi ? _jsxs(Div, { style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        flexDirection: 'column',
                        width: '100%',
                        boxSizing: 'border-box'
                    }, children: [_jsx(Avatar, { size: 96, mode: "app", src: tonConnect2Abount2.iconUrl }), _jsxs(Title, { style: { marginBottom: 8, marginTop: 20 }, level: "3", weight: "2", children: ["Connect to ", tonConnect2Abount2.name, " ?"] }), _jsx(FormItem, { bottom: errorText, style: { width: '100%' }, children: _jsx(Button, { style: { marginTop: '22px' }, stretched: true, size: 'l', onClick: () => setActiveModal('ton_proof'), children: "Connect" }) })] }) : null }), _jsx(ModalPage, { id: 'ton_proof', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: "Sign" }), children: listTokens && walletInfo
                    ? _jsxs(Div, { children: [_jsx(FormItem, { top: "Password", bottom: psw.error, children: _jsx(Input, { value: psw.value, onChange: e => psw.change(e.target.value), status: psw.iserr, type: 'password' }) }), _jsx(FormItem, { bottom: errorText, children: _jsx(Button, { stretched: true, size: "l", onClick: () => tonProof(), disabled: psw.iserr !== 'valid', children: "Sign" }) })] }) : null }), _jsx(ModalPage, { id: 'del_wallet', className: "delab-modal-root delab-modal-root-active delab-modal-height", onClose: () => setActiveModal(null), 
                // settlingHeight={100}
                header: _jsx(ModalPageHeader, { after: !isDesktop && (_jsx(PanelHeaderButton, { onClick: () => setActiveModal(null), children: _jsx(Icon24Dismiss, {}) })), children: "Delete account" }), children: _jsxs(Div, { children: [_jsx(FormItem, { top: "Password", bottom: psw.error, children: _jsx(Input, { value: psw.value, onChange: e => psw.change(e.target.value), status: psw.iserr, type: "password" }) }), _jsx(FormItem, { bottom: errorText, children: _jsx(Button, { style: { marginTop: '22px' }, stretched: true, size: 'l', disabled: psw.iserr !== 'valid', onClick: () => deletedAccount(), children: "Delete" }) })] }) })] }));
    return (_jsxs(AppRoot, { children: [_jsx(SplitLayout, { className: "delab", style: { justifyContent: 'center' }, modal: modalRoot, popout: popout, 
                // header={isDesktop
                //     && <PanelHeader separator={false} className="delab-header" />
                // }
                header: location.pathname !== '/reg' && _jsx(HeaderBlock, { id: "1" }), children: _jsx(SplitCol, { fixed: true, animate: false, spaced: isDesktop, width: isDesktop ? '400px' : '100%', maxWidth: isDesktop ? '400px' : '100%', children: _jsx(Epic, { activeStory: 'main', tabbar: location.pathname !== '/reg' && (_jsxs(Tabbar, { children: [_jsx(TabbarItem, { selected: location.pathname === '/', text: "Wallet", onClick: () => history('/'), children: _jsx(Icon28HomeOutline, {}) }), _jsx(TabbarItem, { selected: location.pathname.indexOf('/nft') > -1, onClick: () => history('/nft'), text: "NFT", children: _jsx(Icon28DiamondOutline, {}) }), _jsx(TabbarItem, { selected: location.pathname === '/apps', text: "Apps", onClick: () => history('/apps'), children: _jsx(Icon28GlobeOutline, {}) }), _jsx(TabbarItem, { selected: location.pathname === '/settings', text: "Settings", onClick: () => history('/settings'), children: _jsx(Icon28SettingsOutline, {}) })] })), children: _jsx("div", { id: "main", children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(View, { activePanel: 'main', id: "view", children: _jsx(Main, { id: "main", addressUser: addressUser, setActiveModal: setActiveModal, setListTokens: setListTokens, setWalletInfo: setWalletInfo, setTransModal: setTransModal, setTransModalFull: setTransModalFull, consoleLog: consoleLog }) }) }), _jsx(Route, { path: "/reg", element: _jsx(View, { activePanel: 'reg', id: "view", children: _jsx(Reg, { id: "reg", addressUser: addressUser, setActiveModal: setActiveModal, setAddressUser: setAddressUser, consoleLog: consoleLog }) }) }), _jsx(Route, { path: "/settings", element: _jsx(View, { activePanel: 'settings', id: "view", children: _jsx(Settings, { id: "settings", addressUser: addressUser, setActiveModal: setActiveModal, setAddressUser: setAddressUser, del_wallet: deletedAccount }) }) }), _jsx(Route, { path: "/apps", element: _jsx(View, { activePanel: 'apps', id: "view", children: _jsx(Apps, { id: "apps", addressUser: addressUser, setActiveModal: setActiveModal, setAddressUser: setAddressUser, del_wallet: deletedAccount }) }) }), _jsx(Route, { path: "/nft", element: _jsx(View, { activePanel: 'nft', id: "view", children: _jsx(Nft, { id: "nft", addressUser: addressUser, setActiveModal: setActiveModal, setAddressUser: setAddressUser, del_wallet: deletedAccount }) }) }), _jsx(Route, { path: "/word", element: _jsx(View, { activePanel: 'word', id: "view", children: _jsx(Word, { id: "word", addressUser: addressUser, setActiveModal: setActiveModal, setAddressUser: setAddressUser, consoleLog: consoleLog }) }) })] }) }) }) }) }), snackbar] }));
};
